import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/careers/page.tsx");
